import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Teachers.SearchHeader.title',
    defaultMessage: 'Trouvez le professeur particulier idéal !',
  },
  subtitle: {
    id: 'Teachers.SearchHeader.subtitle',
    defaultMessage: `Trouvez le Sherpa idéal et programmez un cours d’essai offert`,
  },
});
